import session from '@/services/session';
import { useUserStore } from '@/stores/user';
import abilities from '@/services/abilities';

import { pushToDataLayer } from '@/helpers/trackEvents';

const getUser = async () => {
  const userStore = useUserStore();
  if (!userStore.loaded) {
    userStore.loading = true;
    await userStore.getUser();
    userStore.loading = false;
    if (localStorage.getItem('promo-code')) localStorage.removeItem('promo-code');
  }
  return userStore;
};

const hasAccess = (authorizationByOrganization, workspace) => authorizationByOrganization[workspace.organizationId].is_organization_active;

// Onboarding Required
export const onboardingRequired = async (to, from, next) => {
  if (!session.isAuthenticated()) return next({ name: 'Login', query: to.query });
  const { user } = await getUser();
  if (user.settings.onboardingCompleted) return next({ name: 'Dashboard', query: to.query });
  return next();
};

// Auth Required
export const authRequired = async (to, from, next) => {
  const { token, ...queryParams } = to.query;

  if (token) {
    const jwt = localStorage.getItem('lander-jwt');
    if (jwt) { session.removeToken(); }
    session.setToken(token);
    if (to.query.signupType) {
      pushToDataLayer(session.getUser(), to.query.signupType);
      return next({ name: 'Dashboard', query: queryParams });
    }
    if (to.query.redirect_route) {
      const route = JSON.parse(to.query.redirect_route);
      return next(route);
    }
  }
  if (session.isAuthenticated()) return next({ name: 'Dashboard', query: queryParams });
  return next();
};

// Workspace Access Required
export const workspaceAccessRequired = async (to, from, next) => {
  if (!session.isAuthenticated()) {
    if ((to.name === 'WizardImport' && to.query.url) || (to.name === 'WizardUrl' && to.query.pageUrl)) return next({ name: 'Register', query: to.query });
    return next({ name: 'Login', query: to.query });
  }
  const { user, authorizationByOrganization, workspace } = await getUser();
  if (!user.settings.onboardingCompleted) return next({ name: 'Welcome', query: to.query });
  if (Number(to.params.workspaceId) !== workspace.id) return next({ name: to.name, params: { ...to.params, workspaceId: workspace.id }, query: to.query });
  if (session.getUser() && session.getUser().isImpersonated) return next();
  if (!hasAccess(authorizationByOrganization, workspace)) {
    if (to.name === 'Profile') return next();
    if (abilities.can('access', 'Billing')) {
      if (to.name === 'Account') return next();
      return next({ name: 'Account', params: { tab: 'plans' }, query: to.query });
    }
    if (to.name === 'NoAccess') return next();
    return next({ name: 'NoAccess', query: to.query });
  }
  if ((to.name === 'Settings' && !abilities.can('access', 'CollaborationTools')) || (to.name === 'Account' && !abilities.can('access', 'Billing')) || (to.name === 'Editor' && !abilities.can('update', 'Lander'))) return next({ name: 'Dashboard', query: to.query });
  if (to.name === 'Dashboard') {
    if (to.query.url) return next({ name: 'WizardImport', query: to.query });
    if (to.query.pageUrl) return next({ name: 'WizardUrl', query: to.query });
  }
  return next();
};
